var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container list-page-header"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "list-body container"
  }, [_c('section', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.requests), function(request, index) {
    return _c('tr', {
      key: request['.key']
    }, [_c('td', [_c('router-link', {
      staticClass: "has-text-info",
      attrs: {
        "to": '/requests/' + request.key
      }
    }, [_vm._v(_vm._s(request.Association.Name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(request.Date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.RequesterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.RequesterEmail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.PropertyOwnerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.PropertyAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.LoanNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.Association.Accord24.CertificateHolder))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30px"
      }
    }, [_c('div', {
      staticClass: "is-pulled-right"
    }, [_c('div', {
      ref: 'associationRow' + index,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger"
    }, [_c('div', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.away),
        expression: "away"
      }],
      staticClass: "icon is-small fa-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleActive('associationRow' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "id": "dropdown-menu3",
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openDeleteModal(index)
        }
      }
    }, [_vm._v("\n                            Delete Request\n                          ")])])])])])])])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('h5', [_vm._v("Enter DELETE below to permanently delete request from " + _vm._s(_vm.requests[_vm.deleteIndex].RequesterEmail) + " on " + _vm._s(_vm.formatDate(_vm.requests[_vm.deleteIndex].Date)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin": "-20px 0px 30px 0px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteText),
      expression: "deleteText"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter DELETE"
    },
    domProps: {
      "value": (_vm.deleteText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.deleteText = $event.target.value
      }, function($event) {
        _vm.checkDeleteText(_vm.deleteText)
      }]
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": _vm.disableDeleteContinue
    },
    on: {
      "click": function($event) {
        _vm.deleteRequest(_vm.deleteIndex)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Certificate Requests")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Association")]), _vm._v(" "), _c('th', [_vm._v("Request Date")]), _vm._v(" "), _c('th', [_vm._v("Requester Name")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Property Owner")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("Loan Number")]), _vm._v(" "), _c('th', [_vm._v("Cert. Holder")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65cab6e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/RequestsList.vue
// module id = d/lJ
// module chunks = 1